// There's an issue extending Error in Typescript (I believe for lower versions of JavaScript):
// https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
//
// Here are the solutions I liked the best, but since this is for both node and the browser I went with a library (below):
// https://www.metachris.com/2017/01/custom-errors-in-typescript-2.1/
// https://blog.joefallon.net/2018/09/typescript-try-catch-finally-and-custom-errors/
//
// We use to use ts-custom-error (https://www.npmjs.com/package/ts-custom-error) but it caused more trouble than it was worth.
// We can look at it again later. For new, we'll live with just extending Error
export class PipeValidationError extends Error {
    // Superclass of all pipe validation errors - enables instanceof PipeValidationError checks for cases
    // where we just want to know if a node/pipe is valid, not why they aren't.
    constructor(message) {
        super(message);
    }
}
//# sourceMappingURL=pipeValidationError.js.map